/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Scale_Desc5Inputs */

const en_svc_automation_scale_desc5 = /** @type {(inputs: Svc_Automation_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thousands of jobs, concurrent workers, rate-limit aware execution, automation that scales past a hobby script.`)
};

const ar_svc_automation_scale_desc5 = /** @type {(inputs: Svc_Automation_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آلاف المهام وعمال متوازون وتنفيذ يراعي حدود المعدل, أتمتة تتجاوز سكربت الهواية.`)
};

const bn_svc_automation_scale_desc5 = /** @type {(inputs: Svc_Automation_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হাজার হাজার জব, কনকারেন্ট ওয়ার্কার, রেট-লিমিট-সচেতন এক্সিকিউশন, হবি স্ক্রিপ্টের বাইরে স্কেল করা অটোমেশন।`)
};

const de_svc_automation_scale_desc5 = /** @type {(inputs: Svc_Automation_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tausende Jobs, gleichzeitige Worker, Rate-Limit-bewusste Ausführung, Automatisierung jenseits eines Hobby-Skripts.`)
};

const es_svc_automation_scale_desc5 = /** @type {(inputs: Svc_Automation_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miles de trabajos, workers simultáneos, ejecución consciente del rate limit, automatización más allá de un script de hobby.`)
};

const fr_svc_automation_scale_desc5 = /** @type {(inputs: Svc_Automation_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des milliers de tâches, des workers simultanés, une exécution consciente des rate limits, une automatisation qui dépasse un script de loisir.`)
};

const pt_svc_automation_scale_desc5 = /** @type {(inputs: Svc_Automation_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milhares de jobs, workers simultâneos, execução ciente de rate limit, automação que vai além de um script de hobby.`)
};

const zh_svc_automation_scale_desc5 = /** @type {(inputs: Svc_Automation_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数以千计的作业、并发工作人员、速率限制感知执行、超越爱好脚本的自动化。`)
};

const tr_svc_automation_scale_desc5 = /** @type {(inputs: Svc_Automation_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binlerce iş, eşzamanlı worker'lar ve rate limit'i gözeten yürütme ile hobi script'inin ötesine geçen otomasyon.`)
};

const ru_svc_automation_scale_desc5 = /** @type {(inputs: Svc_Automation_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тысячи джоб, параллельные воркеры, выполнение с оглядкой на рейт-лимиты, автоматизация уровнем выше пет-скрипта.`)
};

const pl_svc_automation_scale_desc5 = /** @type {(inputs: Svc_Automation_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tysiące jobów, workery równoległe, egzekucja świadoma limitów, automatyzacja wykraczająca poza hobbystyczny skrypt.`)
};

/**
* | output |
* | --- |
* | "Thousands of jobs, concurrent workers, rate-limit aware execution, automation that scales past a hobby script." |
*
* @param {Svc_Automation_Scale_Desc5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_automation_scale_desc5 = /** @type {((inputs?: Svc_Automation_Scale_Desc5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Scale_Desc5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_scale_desc5(inputs)
	if (locale === "bn") return bn_svc_automation_scale_desc5(inputs)
	if (locale === "de") return de_svc_automation_scale_desc5(inputs)
	if (locale === "es") return es_svc_automation_scale_desc5(inputs)
	if (locale === "fr") return fr_svc_automation_scale_desc5(inputs)
	if (locale === "pt") return pt_svc_automation_scale_desc5(inputs)
	if (locale === "zh") return zh_svc_automation_scale_desc5(inputs)
	if (locale === "tr") return tr_svc_automation_scale_desc5(inputs)
	if (locale === "ru") return ru_svc_automation_scale_desc5(inputs)
	if (locale === "pl") return pl_svc_automation_scale_desc5(inputs)
	return en_svc_automation_scale_desc5(inputs)
});
export { svc_automation_scale_desc5 as "svc_automation_SCALE_desc" }